import { useEffect, useState } from "react";
import RichTextEditor, { RichTextDisplay } from "./RichTextEditor";
import {
  ensureWeeklyQuestResponse,
  saveWeeklyQuestDraft,
  submitWeeklyQuest,
} from "./weeklyQuests";

export default function WeeklyQuestCard({ prompt, currentUser, onSubmitted, onXpAwarded }) {
  const [responseId, setResponseId] = useState("");
  const [responseText, setResponseText] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [saveStatus, setSaveStatus] = useState("Saved");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function loadResponse() {
      try {
        const response = await ensureWeeklyQuestResponse(prompt, currentUser);

        if (!isMounted) return;

        setResponseId(response.id);
        setResponseText(response.responseText || "");
        setIsPrivate(!!response.isPrivate);
      } catch (error) {
        console.error(error);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    loadResponse();

    return () => {
      isMounted = false;
    };
  }, [prompt, currentUser]);

  useEffect(() => {
    if (!responseId || loading) return;

    const timeout = setTimeout(async () => {
      try {
        setSaveStatus("Saving...");
        await saveWeeklyQuestDraft(responseId, responseText, isPrivate);
        setSaveStatus("Saved");
      } catch (error) {
        console.error(error);
        setSaveStatus("Error saving");
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [responseId, responseText, isPrivate, loading]);

  async function handleSubmit() {
    try {
      const xpReward = Number(prompt.xpReward || 0);
      await submitWeeklyQuest({
        responseId,
        userId: currentUser.uid,
        responseText,
        xpReward,
      });
      if (onXpAwarded && xpReward > 0) onXpAwarded(xpReward);
      if (onSubmitted) onSubmitted();
    } catch (error) {
      console.error(error);
      setSaveStatus("Error submitting");
    }
  }

  if (loading) return <div>Loading weekly quest...</div>;

  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: 12,
        padding: 16,
        marginBottom: 20,
        background: "#f8fbff",
        color: "#1e3a5f",
      }}
    >
      <h2 style={{ marginTop: 0, marginBottom: 8, color: "#1e3a5f" }}>Weekly Quest Prompt</h2>
      <h3 style={{ marginTop: 0, marginBottom: 8, color: "#1e3a5f" }}>{prompt.title}</h3>
      <RichTextDisplay html={prompt.prompt} style={{ marginTop: 0, color: "#4b6b8a", lineHeight: 1.5 }} />

      <div style={{ marginTop: 12 }}>
        <RichTextEditor
          value={responseText}
          onChange={setResponseText}
          placeholder="Type your response here..."
          rows={8}
        />
      </div>

      <label
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          marginTop: 12,
          color: "#1e3a5f",
          fontWeight: "bold",
        }}
      >
        <input
          type="checkbox"
          checked={isPrivate}
          onChange={(e) => setIsPrivate(e.target.checked)}
          style={{ accentColor: "#2563eb", colorScheme: "light", width: 16, height: 16 }}
        />
        Private to coach only
      </label>

      <p style={{ fontSize: 12, color: "#4b6b8a", marginTop: 10 }}>{saveStatus}</p>

      <button
        onClick={handleSubmit}
        style={{
          marginTop: 10,
          padding: "10px 14px",
          borderRadius: "14px",
          border: "2px solid #2563eb",
          background: "#e0f2fe",
          color: "#1e3a5f",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Submit Quest
      </button>
    </div>
  );
}